import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class PaymentRequestInvalidError extends CodedError {
  static get errorName() {
    return errorCodes.paymentRequestInvalidError.code;
  }

  constructor(message: string = errorCodes.paymentRequestInvalidError.message) {
    super(message);
    this.code = errorCodes.paymentRequestInvalidError.code;
    this.message = `${message} ${errorCodes.paymentRequestInvalidError.code}`;
    this.name = errorCodes.paymentRequestInvalidError.name;
  }
}
